import {
  FETCH_TRACKING_PAGE_FAILURE,
  FETCH_TRACKING_PAGE_SUCCESS,
} from 'constants/payment';
import type { Rewards } from 'models/rewards';

type RewardsAction =
  | {
      type: typeof FETCH_TRACKING_PAGE_SUCCESS;
      payload: {
        cashback?: Rewards;
      };
    }
  | { type: typeof FETCH_TRACKING_PAGE_FAILURE };

export const rewards = (
  state: Rewards | Record<string, never> = {},
  action: RewardsAction,
) => {
  switch (action.type) {
    case FETCH_TRACKING_PAGE_SUCCESS:
      const { cashback: { agreedTransaction = {} } = {} } = action.payload;

      return {
        ...state,
        agreedTransaction: agreedTransaction,
      };
    case FETCH_TRACKING_PAGE_FAILURE:
      return {};
    default:
      return state;
  }
};
